import { Platform } from 'react-native';

// Manage Team result table: the Last Sign In column is 15px wider than its original 18% (long
// datetimes wrapped), taken from the Email column so the row still totals 100%. Native has no
// calc(), so it approximates with percentages.
export const LAST_LOGIN_COL_WIDTH = (Platform.OS === 'web' ? 'calc(18% + 15px)' : '20%') as any;
export const EMAIL_COL_WIDTH = (Platform.OS === 'web' ? 'calc(32% - 15px)' : '30%') as any;
